import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/authReducer';
import dataReducer from './reducers/dataReducer';

const store = configureStore({
    reducer: {
        auth: authReducer,
        data: dataReducer,
    },
});

export default store;